import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'

import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const SmartChatActivationModal = ({ isOpen, toggle, onEvent }) => {
  const { includedFreePrice } = useSelector(store => store.currentPlan)
  const [isOpenNotification, setIsOpenNotification] = useState(false)

  const toggleOpenNotification = () => setIsOpenNotification(!isOpenNotification)

  return (
    <>
      <ModalWrapper
        isOpen={isOpen}
        toggle={toggle}
        header={' '}
        body={
          <div className='modal-content--smart-chat'>
            <figure className='emoji'>
              <img src={getStaticImage('/icons/orange-brand/party-face-emoji.png')} alt='Emoji' />
            </figure>
            <strong className='title'>{I18n.t('smartChat_firstActivation_title')}</strong>
            <div>
              <p dangerouslySetInnerHTML={{
                __html: I18n.t(`smartChat_firstActivation_info${includedFreePrice?.smartChat ? '_free': ''}`)
              }} />
            </div>
          </div>
        }
        footer={
          <div className='buttons-container'>
            <Button
              primary
              value={I18n.t('dashboard_accept')}
              onClick={async () => {
                await onEvent()
                toggle()
                toggleOpenNotification()
              }}
            />
            <Button
              value={I18n.t('dashboard_cancel')}
              onClick={toggle}
            />
          </div>
        }
      />
      <ModalWrapper
        isOpen={isOpenNotification}
        toggle={toggleOpenNotification}
        header={' '}
        body={
          <div className='modal-content'>
            <p dangerouslySetInnerHTML={{ __html: I18n.t('smartChat_firstActivation_activated') }}></p>
          </div>
        }
        footer={
          <div className='buttons-container'>
            <Button
              value={I18n.t('dashboard_close')}
              onClick={toggleOpenNotification}
            />
          </div>
        }
      />
    </>
  )
}

export default SmartChatActivationModal
